<template>
  <HeadUp :toHome="toHome"></HeadUp>

  <div class="warn">
      <span><span class="catching">⚠️ 变砖警告：</span>千万别在【设置页面】和【iCloud 页面】登录公用账号！️
      </span>
  </div>

  <div class="intro">
    <div class="step-title">公用 Apple ID 登陆</div>
    <div class="attention">
      <div>
        <span class="attention-step">注意 1</span>
        <span>千万别在【设置页面】和【iCloud 页面】登录！<br> 这会导致您的 App Store 被锁定，甚至导致 <span class="catching">【手机变砖】</span></span>
        <div class="step-imgs">
          <img class="step-screenshot" src="@/assets/images/attention-1.jpg">
          <img class="step-screenshot ml-2rem" src="@/assets/images/attention-2.jpg">
        </div>
      </div>

      <div >
        <span class="attention-step">注意 2</span>
        <span>若提示需要<span class="catching">【电话号码验证】</span><br>代表您操作错误，请仔细查看教程</span>
        <div class="step-imgs">
          <img class="step-screenshot" src="@/assets/images/attention-3.jpg">
        </div>
      </div>
    </div>


    <div class="step-number">1</div>
    <div>
      打开 App Store，点右上角头像<br>
      <img class="step-screenshot" src="@/assets/images/temp_pub_1.jpg">
    </div>
    <div class="step-number">2</div>
    <div>
      &nbsp;&nbsp;不要点账号！<br>
      滑到屏幕底部，退出登录<br>
      <img class="step-screenshot" src="@/assets/images/temp_pub_2.jpg">
    </div>
    <div class="step-number">3</div>
    <div>
      输入公用账号（任选1个）并登录
      <br />
      <br />
      <div class="pub-app-id">
        <div v-if="accounts.length <= 0">
          {{accounts.length}}
          <div class="pub-app-id-acc-flex-wrapper" >
            账号：<span class="pub-app-id-acc">请稍后刷新页面</span><span class="pub-app-id-acc-cp">复制</span>
          </div>
          <div class="pub-app-id-acc-flex-wrapper">
            密码：<span class="pub-app-id-psw">请稍后刷新页面</span><span class="pub-app-id-psw-cp">复制</span>
          </div>
        </div>
        <div v-else>
          <div v-for="account in accounts" :key="account.account">
            <div class="pub-app-id-acc-flex-wrapper" >
              账号：<span class="pub-app-id-acc">{{account.account}}</span><span class="pub-app-id-acc-cp"  @click="copy(account.account)">复制</span>
            </div>
            <div class="pub-app-id-acc-flex-wrapper">
              密码：<span class="pub-app-id-psw">{{account.password}}</span><span class="pub-app-id-psw-cp"  @click="copy(account.password)">复制</span>
            </div>
          </div>
        </div>
      </div>
      <img class="step-screenshot" src="@/assets/images/temp_pub_3.jpg">
    </div>
    <div class="step-number">4</div>
    <div>
      点最下方【其他选项】<br>
      弹窗点【不升级】<br>
      这是公用 ID，非您个人 ID，<br>
      升级账号安全，会导致您的手机变砖！<br>
      <img class="step-screenshot" src="@/assets/images/temp_pub_4.1.jpg">
      <img class="step-screenshot ml-2rem" src="@/assets/images/temp_pub_4.2.jpg">
    </div>
    <div class="step-number">5</div>
    <div>
      您已登录公用  Apple ID<br>
      安装完成后，务必重复 <span class="small-step-number">1</span>&nbsp;<span class="small-step-number">2</span> 退出登录！<br>
      否则您的设备会被锁定，无法使用！<br><br>
      <span class="app-store-like">
        <a @click="downloadInstall()" :href="iosUrl">
        <span>
          <img class="app-icon" src="@/assets/images/icon_app.png"/>
        </span>
          <span>
          <ul>
            <li class="app-title">
              狗急加速
            </li>
            <li class="app-intro">
              将跳转至 AppStore
            </li>
            <li class="app-get">
              安装
            </li>
          </ul>
        </span>
        </a>
      </span>
      <br><br>
    </div>
  </div>
  <div class="flex-item"></div>
  <Footer></Footer>
</template>

<script>
  import { useStore } from "vuex"
  import { ref, reactive } from "vue"

  import HeadUp from '../components/Head.vue'
  import Footer from '../components/Footer.vue'

  import utils from '../utils/utils'
  import {getDomain} from "@/config";
  export default {
    name: 'GuidePubSetting',
    components: {
      Footer,
      HeadUp
    },
    setup () {
      let store = useStore().state
      function setTitle (lang) {
        document.title = store.languages[lang]['title']
      }
      function getTitle () {
        this.$http.get(`${getDomain('oc')}/api/website/vue/lpt-title`)
          .then(data => {
            const _data = data.data.obj
            Object.keys(_data).forEach(k => {
              store.languages[k]['title'] = _data[k]
            })
            setTitle(store.lang)
          })
          .catch(err => {
            console.log(err)
          })
      }

      let iosUrl = ref('https://apps.apple.com/app/id1559485550')
      function getDownloadUrl () {
        this.$http.get(`${getDomain('oc')}/api/website/vue/ios-url`)
          .then(data => {
            const _data = data.data.obj
            iosUrl.vlaue = _data['ios-appstore-url']
          })
          .catch(err => {
            console.log(err)
          })
      }

      let accounts = reactive([])
      function setPublicAccount () {
        this.$http.get(`${getDomain('oc')}/api/website/vue/pub-acc`)
          .then(data => {
            const _data = data.data.obj
            _data.forEach(d=>{
              accounts.push(d)
            })
          })
          .catch(err => {
            console.log(err)
          })
      }
      function copy (value) {
        utils.copy(value)
      }


      function toHome(){
        window.location.href = `${utils.getQuery('from') || 'index'}.html`
      }

      function downloadInstall () {
        utils.statsDownload("ios")
      }

      return {
        setPublicAccount,
        accounts,
        store,
        getTitle,
        setTitle,
        getDownloadUrl,
        toHome,
        iosUrl,
        copy,
        downloadInstall
      }
    },
    created () {
      this.getTitle()
      let lang = utils.getCookie('lang')
      useStore().commit('change', (lang || 'zh'))
      this.setTitle(this.store.lang)
      let html = document.getElementsByTagName('html')[0]
      utils.bindBGCEvent(html, 'white', '#000000')
      this.getDownloadUrl()
      this.setPublicAccount()
      utils.creatCutomerService()
    }
  }
</script>

<style>
  *{
    padding: 0;
    margin: 0;
  }
  body, html {
    font-size: 12px;
  }
  body {
    font-family: Roboto,sans-serif;
    font-weight: 700;
    height: 100%;
    z-index: -1;
    width: 100%;
  }
  .ml-2rem {
    margin-left: 2rem !important;
  }
  ul {
    list-style: none;
  }
  .intro {
    background-color: white;/* Todo: Try to remove this since unreasonable */
    padding: 6rem 0 2rem 0;
    font-size: 1.2rem;
    text-align: center;
    font-weight: 700;
  }


  .warn {
    position: sticky;
    top: 4.7rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .warn > span{
    width: 100%;
    text-align: center;
    background-color:  #FFFABF;
    padding: 1rem 1rem;
  }
  .attention > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 1.2rem;
  }


  .catching {
    color: #ee181b;
  }
  .attention-step {
    padding: 6px 15px;
    border-radius: 18px;
    color: white;
    background-color: #d7202f;
    margin-bottom: 1rem;
  }
  .step-imgs {
    width: 100%;
  }

  .intro span {
    display: inline-block;
    vertical-align: middle;
  }

  .intro ul {
    text-align: center;
  }

  .intro a:hover,
  .intro a:link,
  .intro a:visited,
  .intro a:active {
    color: #0066FF;
    text-decoration: underline;
  }

  .intro .step-title {
    background-color: #CC1424;
    color: white;
    width: 70%;
    max-width: 500px;
    margin: 0 auto 1.2rem auto;
    padding: 0.25rem;
    font-size: 1.5rem;
    border: 3px solid #4D2C22;
    border-radius: 10rem;
    box-shadow: 0 4px 0 0 #00000030;
    -webkit-box-shadow: 0 4px 0 0 #00000030;
    -moz-box-shadow: 0 4px 0 0 #00000030;
  }

  .intro .step-box {
    display: block;
    background-color: #EEEEEE;
    color: black;
    width: 70%;
    max-width: 500px;
    margin: 0 auto 1.2rem auto;
    padding: 1.5rem;
    font-size: 1.2rem;
    border: 3px solid #4D4D4D;
    border-radius: 2rem;
    box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
    -webkit-box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
    -moz-box-shadow: inset 0 4px 0 0 white, 0 4px 0 0 #00000030;
  }

  .intro .step-box hr {
    margin: 1.5rem;
    border: 0;
    border-top: 2px dotted lightgrey;
  }

  .intro .step-number {
    background-color: black;
    color: white;
    border-radius: 10rem;
    border: none;
    margin: auto auto 1.2rem auto;
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
    font-size: 1.2rem;
    text-align: center;
  }

  .intro .step-comment {
    font-size: 1rem;
    color: darkgrey;
  }

  .step-screenshot {
    width: 60%;
    max-width: 200px;
    border-radius: 15px;
    border: 1px dotted lightgrey;
    margin: 1rem auto 3rem auto;
  }

  .intro .app-store-like .app-icon {
    height: 6rem;
    margin-right: .5rem;
    border-radius: 1.4rem;
    display: block;
  }

  .intro .app-store-like ul {
    text-align: left;
  }

  .intro .app-store-like .app-title {
    color: black;
    font-size: 1.5rem;
  }

  .intro .app-store-like .app-intro {
    color: #999999;
    margin-bottom: 0.2rem;
    font-size: 1rem;
  }

  .intro .app-store-like .app-get, .intro .step-button, .intro a.step-button {
    background-color: #0066FF;
    border-radius: 20rem;
    border: none;
    color: white;
    padding: 0.2rem 1.2rem;
    display: inline-block;
    font-size: 1.2rem;
    cursor: pointer;
    text-decoration: none;
  }

  .intro .app-store-like .app-get.unpaid {
    background-color: #b2b2b2;
  }

  .intro .pub-app-id-acc-flex-wrapper {
    width: 80%;
    max-width: 600px;
    margin: auto;
    text-align: left;
    line-height: 3rem;
    border: 0;
    border-top: 1px dotted lightgrey;
    display: flex;
  }

  .intro .pub-app-id-acc, .intro .pub-app-id-psw {
    flex: 1;
  }

  .intro .pub-app-id-acc-cp, .intro .pub-app-id-psw-cp {
    color: #0066FF;
    /*text-decoration: underline;*/
    cursor: pointer;
  }
  .intro .small-step-number{
    background-color: black;
    color: white;
    border-radius: 10rem;
    border: none;
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1.6rem;
    font-size: 1.2rem;
    text-align: center;
    vertical-align: top;
  }

  @media all and  (max-width: 765px) {
    .step-screenshot {
      width: 40%;
    }
    .ml-2rem {
      margin-left: 20px !important;
    }
  }
</style>
